import $ from 'jquery';
import brandContainerInit from '@99designs/brand-container';
import Globalnav from '@99designs/globalnav';

import 'app/modules/datetime';
import 'app/lib/transition-end';
import '@99designs/asimov/core';
import '@99designs/asimov/media-query-label';
import '@99designs/asimov/modal';
import '@99designs/asimov/tooltip';

// Fix https://www.cve.mitre.org/cgi-bin/cvename.cgi?name=2015-9251
// More: https://github.com/jquery/jquery/issues/2432
// Can be removed when on jQuery 3
jQuery.ajaxPrefilter(s => {
    s.contents.script = false;
});

// Initialise asimov-media-query-label outside dom ready check below. It has its own check and we want
// this to fire early on.
$(document).mediaQueryLabel();

$(function() {
    // activate relative date stamps
    $('span.gmttime').dateTime(false);

    document.addEventListener('uiNeedsTimeUpdate', function() {
        $('span.gmttime').dateTime(true);
    });

    // update relative time every minute to provide a countdown
    setInterval(function() {
        document.dispatchEvent(new CustomEvent('uiNeedsTimeUpdate'));
    }, 60000);

    brandContainerInit();

    // activate asimov modals
    $('[data-modal-name]').modal();

    // activate asimov tooltips
    $('[data-tooltip]').tooltip();

    // automatically add CSRF tokens to ajax calls
    var token = $('meta[name="csrf-token"]').attr('content');

    $(document).ajaxSend(function(elm, xhr, s) {
        if (token && s && (s.type === 'POST' || s.type === 'DELETE' || s.type === 'PUT')) {
            xhr.setRequestHeader('X-Csrf-Token', token);
        }
    });

    // globalnav
    const dataNode = document.getElementById('globalnav-data');
    const appNode = document.querySelector('[data-globalnav-notifications-dropdown]');

    // appNode only present for logged in users
    if (dataNode && appNode) {
        const { locale } = JSON.parse(dataNode.textContent);
        Globalnav(appNode, locale);
    }
});



// WEBPACK FOOTER //
// ./src/web/js/app/layout.js